import { Component, h, Host, Prop, State, Element } from '@stencil/core';
import { ImgData } from '../../../../../apps/website/src/app/models/img-data.model';
import { HTMLStencilElement } from '@stencil/core/internal';


@Component({
  tag: 'img-slider',
  styleUrl: 'img-slider.scss',
})
export class ImgSlider {
  @Prop() imagesJson: string;

  @Prop() asideItemsLength: number = 5;

  private images: ImgData[];

  @State() private currentIndex: number;

  @Element() hostElement: HTMLStencilElement;

  get isDesktop() {
    return window.screen.width > 768;
  }

  componentWillLoad() {
    this.initData();
  }

  componentDidLoad() {
    this.removeFallback();
  }

  private initData() {
    const imagesFromDom = this.hostElement.querySelectorAll('div[data-slider-item] img');

    const imagesFromDomStructured: ImgData[] = Array.from(imagesFromDom).map((item: HTMLImageElement) => {

      return {
        path: item.getAttribute('src'),
        domain: null,
        is_main: item.getAttribute('data-main') === 'true',
        alt: item.getAttribute('alt')
      };
    });

    this.images = imagesFromDomStructured ? imagesFromDomStructured : [];
    this.currentIndex = this.images.findIndex(x => x.is_main) || 0;
  }

  private removeFallback() {
    document.getElementById('img-slider-fallback')?.remove();
  }

  render() {
    return <Host>
      {
        this.isDesktop ? <aside-slider
          shownItemLength={this.asideItemsLength}
          images={this.images}
          currentIndex={this.currentIndex}
          itemClick={i => this.currentIndex = i} /> : ''
      }

      <div class='main'>
        <main-slider
          images={this.images}
          initialIndex={this.currentIndex}
          itemSlide={i => this.currentIndex = i}>
        </main-slider>
        <slot />
      </div>
      <slot name='slider-images' />
    </Host>;
  }
}
